import { render, staticRenderFns } from "./nameAdd.vue?vue&type=template&id=0bc98667&scoped=true&"
import script from "./nameAdd.vue?vue&type=script&lang=js&"
export * from "./nameAdd.vue?vue&type=script&lang=js&"
import style0 from "./nameAdd.vue?vue&type=style&index=0&id=0bc98667&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc98667",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/site-front-pipline/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bc98667')) {
      api.createRecord('0bc98667', component.options)
    } else {
      api.reload('0bc98667', component.options)
    }
    module.hot.accept("./nameAdd.vue?vue&type=template&id=0bc98667&scoped=true&", function () {
      api.rerender('0bc98667', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/project/manage/components/nameAdd.vue"
export default component.exports